import React, { useState, useEffect } from "react"
import { onAuthStateChanged } from "firebase/auth"
import Login from "./components/Login"
import Admin from "./components/Admin"
import { getRole } from "./utils/localStorage"
import { auth } from "./firebase"
import Loading from "./components/Layout/Loading"

function App() {
  const [loading, setLoading] = useState(true)
  const [user, setUser] = useState(null)

  const urlSearchParams = new URLSearchParams(window.location.search)
  const params = Object.fromEntries(urlSearchParams.entries())
  const { reload_redirect } = params

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      setUser(firebaseUser)
      setLoading(false)
    })

    return () => unsubscribe()
  }, [])

  if (loading) {
    return <Loading />
  }

  // Is logged in
  if (user && getRole()) {
    return <Admin />
  }

  return <Login reload_redirect={reload_redirect} />
}

export default App
